document.querySelectorAll('.button-collapse-mobile').forEach(button => {
    const subMenu = button.closest('.button-collapse-box').nextElementSibling;

    button.addEventListener('click', function () {
        const verticalLine = this.querySelector('.vertical-line');

        if (subMenu) {
            if (subMenu.classList.contains('active-collapse-mobile')) {

                subMenu.style.height = '0';
                subMenu.classList.remove('active-collapse-mobile');
            } else {

                subMenu.style.height = `${subMenu.scrollHeight}px`;
                subMenu.classList.add('active-collapse-mobile');
            }

            if (verticalLine) {
                verticalLine.style.display = subMenu.classList.contains('active-collapse-mobile') ? 'none' : 'block';
            }
        }
    });
});